import clsx from 'clsx'
import React, {memo} from 'react'

import {CornerDownIcon} from '../../icons'
import {makeStyles, Theme} from '../../theme'

const useArrowStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 24,
    height: '24px !important',
    minWidth: '24px !important',
    padding: 0,
    outline: 'none',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    borderRadius: 4,
    ...theme.go.mixins.effects.Hovered(),
    ...theme.go.mixins.effects.Pressed(),
  },
  arrow: {
    color: theme.go.schemes.colors.system.IconMain,
  },
  arrowRight: {
    transform: 'rotate(-90deg)',
  },
  arrowLeft: {
    transform: 'rotate(90deg)',
  },
}))

export type ArrowButtonProps = {direction?: 'left' | 'right'} & React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>

export const ArrowButton = memo(function ArrowButton({direction, className, ...props}: ArrowButtonProps) {
  const {arrowRight, arrowLeft, arrow, root} = useArrowStyles()

  return (
    <button type="button" {...props} className={clsx(className, root)}>
      <CornerDownIcon
        className={clsx(arrow, direction === 'right' ? arrowRight : direction === 'left' ? arrowLeft : undefined)}
      />
    </button>
  )
})
